<template><div class="ShowHideB">
    <div v-if="!opened" @click="toggle"><slot name="title" ></slot></div>
    <slot v-if="opened"></slot>
    <button v-if="opened" class="ShowHideB--close" @click="toggle"><CloseSvg class="close-icon" /></button>
</div></template>




<style lang="scss">
    @import "@/assets/styles/cruise-styles.scss";
    .ShowHideB {
        position: relative;

        &--close {
            background: transparent;
            margin: 0; padding: 0; border: none;
            position: absolute;
            top: 5px; right: 3px;
            width: 32px; height: 32px;
            svg.close-icon {
                width: 32px; height: 32px;
                fill: $orange;
                stroke: none;
            }
            &:hover {
                svg.close-icon {
                    transform: scale(1.1);
                }
            }
        }
    }
</style>


<script setup>
import {ref, onMounted, computed } from 'vue'
import CloseSvg from '@/comp/Icons/CloseSvg.vue'

const props = defineProps({
    show: {
        type: Boolean,
        default: false,
    },
})

onMounted( () => {
    opened.value = props.show ? true : false
} )



const opened  = ref(false)
const toggle = () => {
    opened.value = !opened.value
}


</script>
